import React, { FC } from 'react';
import * as classes from './ServicesCarouselItem.module.scss';
import { CarouselItemI } from '../../../../../../../interfaces/CarouselItemI';
import cn from 'classnames';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import ArrowRight from '../../../../../../../assets/icons/inline/arrow-right.inline.svg';

interface Props extends CarouselItemI {
  bgColor: string;
}

const ServicesCarouselItem: FC<Props> = ({ title, image, action, bgColor }) => {
  const { t } = useTranslation();
  return (
    <div className={cn(classes.sliderItem)} style={{ backgroundColor: bgColor }}>
      <div className={classes.infoWrapper}>
        <div className={classes.header}>
          <div className={classes.title}>{title}</div>
        </div>
        <div onClick={action} className={classes.link}>
          {t('services.sliderSection.learnMore')}
          <ArrowRight />
        </div>
      </div>
      <div>
        <div className={classes.imgBlock} style={{ backgroundImage: `url("${image}")` }} />
      </div>
    </div>
  );
};

export default ServicesCarouselItem;
